import React from 'react';

const StepsPage = () => {
  return (
    <>
      <div className="section section--how-works mt-5 mb-5">
        <div className="section__content">
          <div className="how-works">
            <div className="how-works__content">
              <div className="how-works__steps">
                <div className="title ">
                  Here’s How It Works In 3 Easy Steps:
                </div>
                <ul>
                  <li data-number="1">
                    Sign up, pay just $39.95 for your first month's service that
                    covers the production and shipping of your 4 customized yard
                    sign riders. We will ship your 4 sign riders within 24 hours
                    via USPS 3 Day Priority mail from our Las Vegas print shop
                    Sign up today for only $39.95/mo and we will print and ship
                    your 4 customized yard sign riders within 24 hours via USPS
                    3 Day Priority mail from our Las Vegas print shop.
                  </li>
                  <li data-number="2">
                    While waiting for the yard sign riders to arrive, you will
                    create your mobile optimized e-listing flyers that the
                    system will send to potential clients. You can import your
                    existing listings from either zillow or realtor.com with our
                    one click import tool making it a fast and easy process.
                  </li>
                  <li data-number="3">
                    Place your new yard sign riders up on your yard signs, and
                    start receiving real time lead notifications any time a
                    potential client texts the # on your sign requesting Price,
                    Pics, and Info about the home. This allows you to start a
                    two way text conversation instantly with the potential
                    client while they are still in front of the house!{' '}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StepsPage;
